export default "__VITE_PUBLIC_ASSET__fdc89de1__"